






















import Vue from 'vue';
import RuleTypeBox from './RuleTypeBox.vue';
import CreateEventTriggered from './CreateEventTriggered.vue';
import CreatePeriodic from './CreatePeriodic.vue';
import CreateTimeField from './CreateTimeField.vue';
import { ScheduleRuleType } from '../../../models/ScheduleRule';
import scheduleRuleVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    CreateEventTriggered,
    CreatePeriodic,
    CreateTimeField,
    RuleTypeBox,
  },
  data() {
    return {
      ScheduleRuleType,
    };
  },
  methods: {
    onSuccess(): void {
      this.$emit('cancel');
      this.$emit('created');
    },
  },
});
